<template>
  <div>
    <div
      style="padding:12px 16px;display: flex;align-items: center;margin-bottom: 0px;margin-top: 10px;">
      <img src="../../../assets/images/icon_yunying.png" alt="" style="width: 20px;height: 20px;">
      <span style="color: #0E193B;font-size: 14px;margin-left: 8px;">{{ $t('龙翼简报.代办事项') }}</span>
    </div>
    <div v-loading="loading">
      <el-row :gutter="20">
        <el-col :span="6" v-if="FailureCount > 0">
          <ToDoItem :title="$t('龙翼简报.车辆故障')" :desc="$t('龙翼简报.车辆故障')" @click="handleFailureClick"
            :value="FailureCount"
            :moreValue="[FailureData.FailureRank.Rank3, FailureData.FailureRank.Rank2, FailureData.FailureRank.Rank1]" />
        </el-col>

        <el-col :span="6" v-if="HighConsumeData.Count > 0">
          <ToDoItem :title="$t('龙翼简报.高能耗')" type="circle" :desc="$t('龙翼简报.当日高耗能车辆')"
            @click="handleHighConsumeClick"
            :value="HighConsumeData.Count + '/' + operationReport.TotalCount"
            :chartData="{ percent: HighConsumePercent, total: operationReport.TotalCount }" />
        </el-col>
        <el-col :span="6" v-if="InspectionData.Count > 0">
          <ToDoItem :title="$t('龙翼简报.巡检异常')" @click="handleInspectionDataClick"
            :desc="$t('龙翼简报.昨日巡检异常车辆')" :value="InspectionData.Count" />
        </el-col>
        <el-col :span="6" v-if="DrivingData.Count > 0">
          <ToDoItem :title="$t('龙翼简报.驾驶行为差')" @click="handleDrivingDataClick" type="circle"
            :desc="$t('龙翼简报.昨日驾驶评分低的车辆')"
            :value="DrivingData.Count + '/' + DrivingData.TotalCount"
            :chartData="{ percent: DrivingDataPercent, total: DrivingData.TotalCount }" />
        </el-col>

        <el-col :span="6" v-if="MaintainData.Count > 0">
          <ToDoItem :title="$t('龙翼简报.维修中')" type="circle" :desc="$t('龙翼简报.维修中的车辆')"
            @click="handleMaintainDataClick"
            :value="MaintainData.Count + '/' + MaintainData.TotalCount"
            :chartData="{ percent: MaintainDataPercent, total: MaintainData.TotalCount }" />
        </el-col>
        <el-col :span="6" v-if="LongStayData.Count > 0">
          <ToDoItem :title="$t('龙翼简报.长期未联网')" @click="handleLongStayDataClick" type="circle"
            :desc="$t('龙翼简报.长期未联网的车辆')"
            :value="LongStayData.Count + '/' + LongStayData.TotalCount"
            :chartData="{ percent: LongStayDataPercent, total: LongStayData.TotalCount }" />
        </el-col>
        <el-col :span="6" v-if="(activeTab == '1' || activeTab == '3') && LowOilData.Count > 0">
          <ToDoItem :title="$t('龙翼简报.低油量')" type="circle" :desc="$t('龙翼简报.油量低于')"
            @click="handleLowOilDataClick"
            :value="LowOilData.Count + '/' + LowOilData.TotalCount"
            :chartData="{ percent: LowOilDataPercent, total: LowOilData.TotalCount }" />
        </el-col>
        <el-col :span="6" v-if="activeTab == '5' && LowBetteryData.Count > 0">
          <ToDoItem :title="$t('龙翼简报.低电量')" type="circle" @click="handleLowBetteryDataClick"
            :desc="$t('龙翼简报.电量低于')"
            :value="LowBetteryData.Count + '/' + LowBetteryData.TotalCount"
            :chartData="{ percent: LowBetteryDataPercent, total: LowBetteryData.TotalCount }" />
        </el-col>
      </el-row>
    </div>
  </div>
</template>
<script>
import ToDoItem from "./ToDoItem";
export default {
  name: "DashboardTodoItems",
  components: {
    ToDoItem
  },
  props: {
    loading: {
      type: Boolean,
      default: false
    },
    operationReport: {
      type: Object,
      default: () => ({})
    },
    FailureData: {
      type: Object,
      default: () => ({
        FailureRank: {
          Rank3: 0,
          Rank2: 0,
          Rank1: 0
        }
      })
    },
    HighConsumeData: {
      type: Object,
      default: () => ({
        Count: 0
      })
    },
    InspectionData: {
      type: Object,
      default: () => ({
        Count: 0
      })
    },
    DrivingData: {
      type: Object,
      default: () => ({
        Count: 0,
        TotalCount: 0
      })
    },
    MaintainData: {
      type: Object,
      default: () => ({
        Count: 0,
        TotalCount: 0
      })
    },
    LongStayData: {
      type: Object,
      default: () => ({
        Count: 0,
        TotalCount: 0
      })
    },
    LowOilData: {
      type: Object,
      default: () => ({
        Count: 0,
        TotalCount: 0
      })
    },
    LowBetteryData: {
      type: Object,
      default: () => ({
        Count: 0,
        TotalCount: 0
      })
    },
    HighConsumePercent: {
      type: String,
      default: "0"
    },
    DrivingDataPercent: {
      type: String,
      default: "0"
    },
    MaintainDataPercent: {
      type: String,
      default: "0"
    },
    LongStayDataPercent: {
      type: String,
      default: "0"
    },
    LowOilDataPercent: {
      type: String,
      default: "0"
    },
    LowBetteryDataPercent: {
      type: String,
      default: "0"
    },
    activeTab: {
      type: String,
      default: "3"
    }
  },
  computed: {
    FailureCount() {
      return this.FailureData.FailureRank.Rank3 + this.FailureData.FailureRank.Rank2 + this.FailureData.FailureRank.Rank1;
    }
  },
  methods: {
    handleFailureClick() {
      this.$emit('failure-click');
    },
    handleHighConsumeClick() {
      this.$emit('high-consume-click');
    },
    handleInspectionDataClick() {
      this.$emit('inspection-click');
    },
    handleDrivingDataClick() {
      this.$emit('driving-click');
    },
    handleMaintainDataClick() {
      this.$emit('maintain-click');
    },
    handleLongStayDataClick() {
      this.$emit('long-stay-click');
    },
    handleLowOilDataClick() {
      this.$emit('low-oil-click');
    },
    handleLowBetteryDataClick() {
      this.$emit('low-battery-click');
    }
  }
};
</script>